import { IconLocation, Text } from 'braid-design-system';

interface Props {
  homeLocation: string;
}

export const Location = ({ homeLocation }: Props) => (
  <Text
    icon={<IconLocation tone="secondary" data={{ testid: 'location-icon' }} />}
    size="small"
  >
    {homeLocation}
  </Text>
);
